// extracted by mini-css-extract-plugin
export var switchOption = "switch-module--switchOption--96bcd";
export var switchOptionActive = "switch-module--switchOptionActive--014ee";
export var switchRoot = "switch-module--switchRoot--5a539";
export var switchSlider = "switch-module--switchSlider--1ca18";